// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import expandImg from '../../images/main/select2.png'

const Trigger: StyledComponent<Object, any, any> = styled.div`
  font-size: 14px;
  padding-left: 15px;
  position: relative;
`

const Pointer: StyledComponent<Object, any, any> = styled.div`
  display: inline-block;
  position: absolute;
  margin-left: -15px;
  width: 15px;
  height: 15px;
  background: transparent url(${expandImg}) no-repeat;
  background-position: ${({ isOpen }: Object) => (isOpen ? '-18px -4px' : '0px -4px')};
`

const Content: StyledComponent<Object, any, any> = styled.div`
  padding-top: 25px;
  ${({ isOpen }: Object) => (isOpen ? '' : 'display: none')};
`

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  padding-top: 10px;
`

type Props = {|
  defaultIsOpen?: boolean,
  link: string,
  children: any
|}

type State = {|
  isOpen: boolean
|}

export default class AdditionalParameters extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      isOpen: props.defaultIsOpen || false
    }
  }

  onClickTrigger() {
    this.setState((state) => this.setState({ isOpen: !state.isOpen }))
  }

  render() {
    const { isOpen } = this.state

    return (
      <Wrapper isOpen={isOpen}>
        <Trigger onClick={() => this.onClickTrigger()}>
          <Pointer isOpen={isOpen} />
          <a href="#" onClick={(e) => e.preventDefault()}>
            {this.props.link}
          </a>
        </Trigger>
        <Content isOpen={isOpen}>{this.props.children}</Content>
      </Wrapper>
    )
  }
}
